'use strict';

wbApp.directive('wbCourseTypeLookup', ['$timeout', '$translate', 'courseTypeSvc',
    function ($timeout, $translate, courseTypeSvc) {

        function format(courseType) {
            if (courseType.id) return courseType.name; 
        }

        function filterData(data, courseTypes, filterByCourseTypes) {
            courseTypes.$promise.then(function (ar) {
                var fres = _.filter(ar, function (r) {
                    return !filterByCourseTypes || !!filterByCourseTypes[r.id];
                });

                data.length = 0;
                data.push.apply(data, fres);
            });
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            scope: {
                allowClear: '=',
                filterByCourseTypes: '='
            },
            link: function (scope, elm, attrs, ctrl) {

                var lookupData = courseTypeSvc.getAllForLookup();
                var data = [];

                filterData(data, lookupData, scope.filterByCourseTypes);

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_PLACEHOLDER_SELECT_COURSE_TYPE'),
                        dropdownAutoWidth: true,
                        allowClear: scope.allowClear || false,
                        minimumResultsForSearch: -1,
                        formatResult: format,
                        formatSelection: format,
                        data: data
                    });

                    ctrl.$render();
                });

                scope.$watch('filterByCourseTypes', function (value) {
                    filterData(data, lookupData, value);
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    if (!viewValue) {
                        return 0;
                    } else {
                        return parseInt(viewValue);
                    }
                });

                ctrl.$formatters.unshift(function (value) {
                    if (!value) {
                        return "";
                    } else {
                        return value + "";
                    }
                });

                ctrl.$render = function () {
                    lookupData.$promise.then(function () {
                        elm.select2('val', ctrl.$viewValue);
                    });
                };

                attrs.$observe('readonly', function (value) {
                    elm.select2('readonly', !!value);
                });

                elm.bind("$destroy", function () {
                    elm.select2("destroy");
                });
            }
        }
    }]);
